// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"557eb118","212":"7fe95a9f","268":"fdb79a15","398":"50f3b860","407":"bb237bbf","496":"fd275544","502":"f59c0bb3","608":"13bf30d4","757":"63bc64b9","824":"deb71662","826":"60f5440b","917":"7e68a852","969":"5af5f121","986":"d76b3143","991":"878e5699"}[chunkId] + ".chunk.js";
};